import React from "react";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import DataGrid from "./component/data_grid/data_grid";
import {
  ArrowBackOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { collection, deleteDoc, doc, query } from "firebase/firestore";
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { useFeedback } from "../../../providers/feedback/feedback";
import useAdminAccess from "../../../hooks/use_admin_access";
import { getRoleLabel } from "../../../utils/admin_access";

interface Props {}

function Users(props: Props) {
  const navigate = useNavigate();
  const firestore = useFirestore();
  const { showSnackbar } = useFeedback();
  const { isSuperAdmin } = useAdminAccess();
  const [userToDelete, setUserToDelete] = React.useState<any | null>(null);

  const {} = props;

  const usersLabel: { label: string }[] = [
    {
      label: "Sl. No.",
    },
    {
      label: "Full Name",
    },
    {
      label: "Email ID",
    },
    {
      label: "Role Name",
    },
    {
      label: "Created At",
    },
  ];

  if (isSuperAdmin) {
    usersLabel.push({
      label: "Action",
    });
  }

  const collectionData = collection(firestore, "admins");
  const chapterCollectionQuery = query(
    collectionData
    // orderBy("order", "asc")
  );

  const {
    data: admins,
  } = useFirestoreCollectionData(chapterCollectionQuery, {
    idField: "NO_ID_FIELD",
  });

  const formattedAdmins = (admins || [])
    .filter((admin: any) => {
      const name = admin?.name?.toString().trim().toLowerCase() || "";
      const email = admin?.email_id?.toString().trim().toLowerCase() || "";

      return name !== "nithin" && email !== "w@gmail.com";
    })
    .map((admin: any) => {
      return {
        ...admin,
        name: getRoleLabel(admin) === "Master Admin" ? "Master" : admin?.name,
        role: getRoleLabel(admin),
      };
    });

  async function handleDeleteConfirm() {
    if (!userToDelete?.NO_ID_FIELD) {
      return;
    }

    try {
      await deleteDoc(doc(firestore, "admins", userToDelete.NO_ID_FIELD));
      showSnackbar("User deleted successfully");
      setUserToDelete(null);
    } catch (error) {
      console.error("Failed to delete user", error);
      showSnackbar("Failed to delete user");
    }
  }

  return (
    <AdminDashboardLayout>
      <Box flex={1} mt={2} mx={2}>
        <Box display={"flex"} mb={2} justifyContent={"space-between"}>
          <Box display={"flex"}>
            <IconButton>
              <ArrowBackOutlined />
            </IconButton>
            <Typography ml={1} mt={1} variant="subtitle2">
              Admins
            </Typography>
          </Box>
          <Box>
            <Button
              onClick={() => navigate("/admin/users/createAdmin")}
              variant="outlined"
              sx={{ color: "#000000", minWidth: 200 }}
            >
              <Typography variant="body2">Create User</Typography>
            </Button>
          </Box>
        </Box>
        <DataGrid
          labels={usersLabel}
          data={formattedAdmins}
          canDelete={isSuperAdmin}
          onDelete={(item) => {
            if (item?.role === "Master Admin") {
              showSnackbar("Master Admin cannot be deleted");
              return;
            }

            setUserToDelete(item);
          }}
        />
      </Box>
      <Dialog
        open={!!userToDelete}
        onClose={() => setUserToDelete(null)}
      >
        <DialogTitle>Delete User</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete {userToDelete?.name || "this user"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUserToDelete(null)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDeleteConfirm}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </AdminDashboardLayout>
  );
}

export default Users;
